export const categoryInitialValues = {
  categories: [],
  categoryLoader: false,
};
